// checkShouldDisplayKaraokeTooltip.js
'use strict';
import { FEATURE_LIVESTREAM_INSTANT_COMMAND_TOOLTIP } from '../RemoteConfigKeys.js';
import getCurrentUnixTimestamp from '../resource/getCurrentUnixTimestamp.js';
import { MERGE_OPERATION_DATA } from '../ActionTypes.js';
import getOperationData from '../selector/getOperationData.js';
import getRemoteConfigData from '../selector/getRemoteConfigData.js';

const TOOLTIP_DURATION_SECONDS = 3 * 24 * 60 * 60; // 3 days

/**
 * Check live stream karaoke tooltip
 * @kind action
 * @return {Promise} Action promise.
 */
const checkShouldDisplayKaraokeTooltip = () => async (dispatch, getState) => {
  const state = getState();
  const shouldUseInstantCommandTooltip = !!getRemoteConfigData(
    state,
    FEATURE_LIVESTREAM_INSTANT_COMMAND_TOOLTIP
  );
  const lastTooltipTimestamp =
    getOperationData(state, ['liveStream'], 'tooltipTimestamp') || 0;
  const now = getCurrentUnixTimestamp();
  if (
    shouldUseInstantCommandTooltip ||
    !lastTooltipTimestamp ||
    now - lastTooltipTimestamp > TOOLTIP_DURATION_SECONDS
  ) {
    return dispatch({
      type: MERGE_OPERATION_DATA,
      payload: {
        selectPath: ['liveStream'],
        data: { tooltipTimestamp: now, shouldDisplayKaraokeTooltip: true },
      },
    });
  }
  return dispatch({ type: '' });
};

export default checkShouldDisplayKaraokeTooltip;
